import { render, staticRenderFns } from "./IncomeSourcesEditPage.vue?vue&type=template&id=1600b365&"
import script from "./IncomeSourcesEditPage.vue?vue&type=script&lang=js&"
export * from "./IncomeSourcesEditPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports